/** Map layer keys locked for free plan users */
export const LOCKED_MAP_LAYER_KEYS = new Set([
  "radar",
  "satellite",
  "precipitation",
  "wind",
  "visibility",
  "pressure",
  "snowfall",
  "roadCondition",
  "observation",
]);

/** Sidebar menu `name` → display name for upgrade modal */
export const LOCKED_NAV_FEATURE_NAMES = {
  Forecast: "Forecast",
  Radar: "Radar",
  Alerts: "Alerts",
  Chat: "Chat with Meteorologist",
};

export const LOCKED_NAV_KEYS = new Set(Object.keys(LOCKED_NAV_FEATURE_NAMES));

/** Map layer key → human-readable feature name */
export const MAP_LAYER_FEATURE_NAMES = {
  radar: "Radar",
  satellite: "Satellite",
  precipitation: "Precipitation",
  wind: "Wind",
  visibility: "Visibility",
  pressure: "Pressure",
  snowfall: "Snow Depth",
  roadCondition: "Road Condition",
  observation: "Observations",
};

export const UPGRADE_FEATURE_BULLETS = [
  "Live weather intelligence",
  "Advanced map layers",
  "Real-time alerts",
  "Premium forecasting tools",
];

export const DEFAULT_UPGRADE_REDIRECT = "/Pricing";

const UPGRADE_DESCRIPTIONS = {
  Radar:
    "Upgrade to access premium Radar tools, live weather data, and advanced map layers.",
  Satellite:
    "Unlock high-resolution satellite imagery and cloud analysis with a premium subscription.",
  Precipitation:
    "Track rain, snow, and storm intensity in real time with premium precipitation layers.",
  Wind:
    "Visualize wind speed and direction fields with advanced premium map tools.",
  Visibility:
    "Monitor visibility conditions and hazards using premium observation layers.",
  Pressure:
    "Analyze atmospheric pressure patterns with professional-grade map data.",
  "Snow Depth":
    "Access snow depth and winter storm layers built for operational decisions.",
  "Road Condition":
    "See road weather impacts and travel risk with premium road condition data.",
  Observations:
    "Unlock combined observation overlays including feels-like, humidity, and wind.",
  Forecast:
    "Access extended forecasts, detailed outlooks, and premium weather intelligence.",
  Alerts:
    "Stay ahead with real-time weather alerts and customizable notifications.",
  "Chat with Meteorologist":
    "Get direct access to expert weather guidance by upgrading your plan.",
};

export function getLayerFeatureName(layerKey) {
  return MAP_LAYER_FEATURE_NAMES[layerKey] || layerKey;
}

/** Layer toggles shown on map pages (Layers / LatestMapsGl). */
export const MAP_LAYER_CONTROLS = [
  { key: "observation", icon: "🔮", label: "Observation", featureName: "Observations" },
  { key: "temperature", icon: "🌡️", label: "Temperature" },
  { key: "radar", icon: "📡", label: "Radar" },
  { key: "satellite", icon: "🛰️", label: "Satellite" },
  { key: "precipitation", icon: "🌧️", label: "Precipitation" },
  { key: "wind", icon: "💨", label: "Wind" },
  { key: "visibility", icon: "👁️", label: "Visibility" },
  { key: "pressure", icon: "📊", label: "Pressure" },
  { key: "snowfall", icon: "❄️", label: "Snow Depth" },
  { key: "roadCondition", icon: "🛣️", label: "Road Condition" },
];

export function getUpgradeDescription(featureName) {
  return (
    UPGRADE_DESCRIPTIONS[featureName] ||
    `Upgrade to unlock ${featureName} and access premium weather tools across the platform.`
  );
}
